import React from 'react';
import qs from 'qs';
import { connect } from 'react-redux';
import { userLogin } from 'react-admin';
import { Button } from '@material-ui/core';
import { read } from "./authProvider";

const LoginUi = () => (
  <div style={{width: '100vw', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column'}}>
    <h3>Portal</h3>
    <Button variant="contained" color="primary" onClick={() => window.location = '/login/microsoft'}>
      Login
    </Button>
  </div>
);

const Login = (props) => {
  try {
    let token = read();

    // If a user is logged in, then we redirect to the front of the portal.
    // This handles getting the token out of the url
    if (token && token.role) {
      window.location = '/';
      return null;
    }
  } catch (err) { /** This will fail whenever a valid token is not present **/ }

  const query = qs.parse(window.location.search.substr(1));

  if (query.token) {
    props.userLogin({ token: query.token }, 'login');
  }

  return <LoginUi />;
};

export default connect(null, { userLogin })(Login);


// WEBPACK FOOTER //
// ./resources/assets/js/login.js